export default "__VITE_ASSET__DTJJRwgh__"